<template>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-md-9 col-sm-9" v-if="history.length > 0">
          <table class="table table-lg table-hover job-title" style="table-layout:fixed">
            <thead>
              <tr>
                <th width="300">职位</th>
                <th>地区</th>
                <th>申请日期</th>
                <th>薪资详情</th>
                <th width="140">&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="job in history" :key="job.id">
                <td>
                  <img :src="job.vacancy.recruiting_company.photo_url" class="avatar avatar-lg" alt="Avatar" style="float:left"><p class="elli">{{ job.vacancy.title.name }}<br><span class="mng-jb1">{{ job.vacancy.company_desc || job.vacancy.recruiting_company.name.name }}</span><br>
                  <!--<span class="skill-tag" v-if="job.vacancy.featured">{{ $t('jobs.featured') }}</span>-->
                  <el-tag size="mini" :type="job.apply_status == 'out' ? 'info' : 'danger'">{{ applyStatus(job.apply_status) }}</el-tag>
                  </p>
                </td>
                <td><i class="ti-location-pin"></i> {{ $i18n.locale === 'zh' ? job.vacancy.work_location.c_fullname : job.vacancy.work_location.e_fullname }}</td>
                <td>{{ job.create_at | dateFormat('YYYY-MM-DD') }}</td>
                <td>{{ salaryLabel(job.vacancy.salary_from, job.vacancy.salary_to, job.vacancy.salary_negotiable) }}</td>
                <td>
                  <a href="javascript:void(0)" class="btn theme-btn-outlined mrg-5" @click="getDetail(job.id)">查看进度</a>
                </td> 
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-md-12">
              <Pagination :currentPage.sync="currentPage" :numPerPage="pageSize" :total="total" />
            </div>
          </div>
        </div>
        <div class="col-md-9 col-sm-12" v-else>
          <div class="row mrg-bot-20">
            <h3>暂时没有应聘记录</h3>
          </div>
        </div>
        <div class="col-md-3 col-sm-12">
          <SideAds />
        </div>
      </div>
      <!-- End Row -->
      <div class="modal fade" id="application-detail" tabindex="-1" role="dialog" aria-labelledby="applicationDetail" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content" id="applicationDetail">
            <div class="modal-header">
                  <h4 class="modal-title">应聘进度</h4>
              </div>
            <div class="modal-body">
              <!-- Tab panels -->
              <div class="tab-content">
                <!-- Employer Panel 1-->
                <div class="tab-pane fade in show active" id="employer" role="tabpanel">
                  <div class="row mrg-bot-20">
                    <el-timeline>
                      <el-timeline-item
                        v-for="(d, index) in detail"
                        :key="d.transaction.id || index"
                        :timestamp="d.transaction.issued_at | dateFormat('from', $i18n.locale)">
                        {{ applyStatus(d.added.apply_status) }}
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </div>
                <!--/.Panel 1-->
              </div>
              <!-- Tab panels -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style>
.widget-boxed {
  margin-bottom:20px;
}
.job-title td {
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
</style>
<script>
/* global $ */
import SideAds from '@/components/SideAds.vue'
import Pagination from '@/components/Pagination.vue'

export default {
  name: 'ApplicationList',
  components: {
    SideAds,
    Pagination
  },
  data: () => ({
  history: [],
  detail: [],
  pageSize: 10,
  total: 0,
    pages: 0,
    currentPage: 1
  }),
  computed: {
    
  },
  watch: {
    currentPage: function() {
      this.getData()
    }
  },
  methods: {
    getDetail: function(jobId) {
      let that = this
      this.$http.get(this.API_PREFIX + '/api/app_history/' + jobId).then(function (response) {
        that.detail = response.data.objects
        $('#application-detail').modal('show')
      }).catch(function (error) {
          console.log(error)
        })
    },
    getData: function() {
      let that = this,
          query = 'page=' + this.currentPage + '&extra=job_summary&q=%7B%22order_by%22%3A%5B%7B%22field%22%3A%22id%22%2C%22direction%22%3A%22desc%22%7D%5D%7D'

       this.$http.get(this.API_PREFIX + '/api/vacancy_candidate?' + query).then(function (response) {
          let jobs = response.data.objects
          that.total = response.data.num_results
          
      that.pages = response.data.total_pages
          jobs.forEach(function(job) {
            let img = '/img/no-logo.heic', photo = null
            that.normalizeName(job.vacancy.title)
            if (job.vacancy.recruiting_company) {
              that.normalizeCompany(job.vacancy.recruiting_company.name)
              photo = job.vacancy.recruiting_company.photo
            } else {
              job.vacancy.recruiting_company = {};
            }
            if (photo) {
              let ext = photo.filename.substr(photo.filename.lastIndexOf('.') + 1)
              img = that.IMG_PREFIX + photo.path + '/' + photo.id + '_company_photo_m.' + ext + '?r=' + Math.random()
            }
            job.vacancy.recruiting_company.photo_url = img
            job.vacancy.featured = false            
          })
          that.history = jobs
       }).catch(function (error) {
         console.log(error)
       })
    }
  },
  created: function() {
    this.getData()
  }
}
</script>